// 사용자가 확인한 결정트리 사실(fact_key → 값)의 검색어별 세션 저장소.
// 전체 탭의 사전 점검 카드, 웹 검색 의미 넓히기 재검색, PROVE 작업공간이 같은 품목의
// 확인 사실을 공유하기 위한 얇은 계층이다. 세션 밖으로 나가지 않고, 브라우저 저장이
// 막혀 있으면 조용히 빈 값으로 동작한다.

import { productFactsOnly } from './productFactDialogue';

const PREFIX = "loginhs:tree-facts:";
export const CONFIRMED_FACTS_SCHEMA = 2;
export const TREE_FACTS_UPDATED_EVENT = "loginhs:tree-facts-updated";

const normalizeQuery = (q) => String(q || "").trim().replace(/\s+/g, " ");

export function treeFactKey(q) {
  return `${PREFIX}${normalizeQuery(q)}`;
}

function sanitize(facts) {
  const out = {};
  Object.entries(productFactsOnly(facts)).forEach(([key, value]) => {
    if (!key || value === undefined || value === null || value === "") return;
    // productFactsOnly already validates the one supported structured manifest.
    out[key] = value;
  });
  return out;
}

export function loadTreeFacts(q) {
  const query = normalizeQuery(q);
  if (!query) return {};
  try {
    const raw = sessionStorage.getItem(treeFactKey(query));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed?.schema === CONFIRMED_FACTS_SCHEMA ? sanitize(parsed.facts) : {};
  } catch {
    return {};
  }
}

export function saveTreeFacts(q, facts, source = null) {
  const query = normalizeQuery(q);
  const clean = sanitize(facts);
  if (!query) return clean;
  try {
    const unverified = loadUnverifiedTreeFacts(q);
    Object.keys(clean).forEach((key) => delete unverified[key]);
    sessionStorage.setItem(treeFactKey(query), JSON.stringify({
      schema: CONFIRMED_FACTS_SCHEMA, facts: clean, source: "user_confirmation", confirmed_at: new Date().toISOString(),
      unverified,
    }));
  } catch {
    /* 저장 불가 환경에서는 메모리 상태만 사용한다. */
  }
  window.dispatchEvent(new CustomEvent(TREE_FACTS_UPDATED_EVENT, {
    detail: { key: treeFactKey(query), facts: clean, source },
  }));
  return clean;
}

/** 이전 저장값에는 자동 선택과 사용자 답이 섞여 있어 재확인 후보로만 읽는다. */
export function loadUnverifiedTreeFacts(q) {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(treeFactKey(q)) || "null");
    return parsed?.schema === CONFIRMED_FACTS_SCHEMA ? sanitize(parsed.unverified) : parsed ? sanitize(parsed) : {};
  } catch { return {}; }
}

export function hasTreeFactSnapshot(q) {
  try { return JSON.parse(sessionStorage.getItem(treeFactKey(q)) || "null")?.schema === CONFIRMED_FACTS_SCHEMA; }
  catch { return false; }
}

export function mergeTreeFacts(q, facts) {
  return saveTreeFacts(q, { ...loadTreeFacts(q), ...sanitize(facts) });
}

/** 검색어가 확장(웹 의미 넓히기)되어 바뀔 때 원 검색어의 확인 사실을 새 검색어로 이어 준다. */
export function copyTreeFacts(fromQ, toQ) {
  const facts = loadTreeFacts(fromQ);
  if (normalizeQuery(fromQ) === normalizeQuery(toQ)) return facts;
  return saveTreeFacts(toQ, { ...loadTreeFacts(toQ), ...facts });
}

export function clearTreeFacts(q) {
  try {
    sessionStorage.removeItem(treeFactKey(q));
  } catch {
    /* ignore */
  }
}
